<div class="text-center" *ngIf="data" >
    <div>
      <div  mat-dialog-content>
          <mat-icon [color]="data.color" *ngIf="data.icon">{{data.icon}}</mat-icon>
          <div style="font-weight: bold;
          font-size: 17px;
          margin-bottom: 2px;">{{data.title}}</div>
          <p class="mb-4 font-weight-600 font-size-14" > {{data.body}}</p>
              
      </div>   
      <div  >
        <button *ngFor="let b of data.btns_lst" mat-flat-button [color]="b.color" [border]="b.border" [ngClass]="b.title == 'Ok' ? 'ok_cls' : 'cncl_cl'"
          (click)="onBtnClick(b.cb_res)">{{b.title}}</button>
      </div> 
    </div>
</div>